 

import React, { useState, useEffect } from "react";
import axios from "axios"; // Make sure to install axios: npm install axios
import './Mystreybox.scss';
import Environment from "utils/environment";
  const val = localStorage.getItem("accessToken");

const Mystreybox = () => {
     const [capValue, setCapValue] = useState('');

     const [isToggled, setIsToggled] = useState(false);
    
     
    const [isToggleDisabled, setIsToggleDisabled] = useState(true);

     const [isSuccess, setIsSuccess] = useState(false);

     const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const BAS_URL = Environment.base_url

    // --- 1. FIRST API CALL: Fetch initial data when the component mounts ---
    useEffect(() => {
        const fetchInitialCapValue = async () => {
            try {
                // Set initial states
                setLoading(true);
                setError(null);

                const response = await axios.get(`${BAS_URL}/discounts/mystery/box`,{
                     headers: {
        Authorization: "Bearer " + val,
      },
                });
                
                // Assuming the response data has a 'cap' property.
                // Example response: { data: { cap: 50, ...other_data } }
                if (response.data) {
                    setCapValue(response.data.data[0].cap);
                }

            } catch (err) {
                console.error("Error fetching initial mystery box data:", err);
                setError("Failed to load mystery box data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialCapValue();
    }, []); // Empty dependency array means this runs only once on mount

    // --- 2. Handle changes in the input field ---
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setCapValue(newValue);

        // Enable the toggle switch only if the input field has a value
        // Otherwise, disable it.
        setIsToggleDisabled(newValue === '');
    };

    // --- 3. Handle the toggle switch action ---
    const handleToggle = async () => {
        // Prevent action if disabled
        if (isToggleDisabled) return;

        // Visually check the toggle immediately for better user experience
        setIsToggled(true);
        setError(null); // Clear previous errors

        try {
            // --- SECOND API CALL: PATCH the new value ---
            // The ID is hardcoded to '1' as requested
            const apiUrl = `${BAS_URL}/discounts/mystery/box/1`;
            
            // The body of the request includes the new cap value
            const payload = { cap: capValue };

            await axios.patch(apiUrl, payload,{
                             headers: {
        Authorization: "Bearer " + val,
      },
            });

            // --- On Success ---
            // a. Show green background
            setIsSuccess(true);
            
            // b. After 5 seconds, reset everything
            setTimeout(() => {
                setIsSuccess(false);    // Remove green background
                setIsToggled(false);    // Uncheck the toggle
            }, 5000); // 5000 milliseconds = 5 seconds

        } catch (err) {
            console.error("Error updating mystery box:", err);
            setError("Failed to update the value. Please try again.");
            // If the API call fails, uncheck the toggle immediately so the user can try again
            setIsToggled(false);
        }
    };

    return (
        <>
            <h1 className='mystryheader'>Mystery Box</h1>
            
            {/* Add a dynamic class for the success background */}
            <div className={isSuccess ? 'mystrymain success-bg' : 'mystrymain'}>
                <img className='imgmystrybox' src="/mystrygiftbox/mystrygitbox.svg" alt="Mystery Gift Box" />
                
                <h4 className='mystryinputdigit' style={{ color: 'white' }}>
                    cap
                    <input 
                        className='inputmystryfieldchld' 
                        type="text"
                        value={capValue}
                        onChange={handleInputChange}
                        disabled={loading} // Disable input while initial data is loading
                    />
                </h4>

                <div className="switch-input">
                    <input
                        id="cmn-toggle-1" // It's good practice to have a unique ID for the input
                        className="tgl tgl-ios"
                        type="checkbox"
                        checked={isToggled}
                        onChange={handleToggle}
                        disabled={isToggleDisabled || loading} // Disable if no input value OR if loading
                    />
                    <label
                        htmlFor="cmn-toggle-1" // The 'for' attribute should match the input's 'id'
                        className="tgl-btn"
                    ></label>
                </div>
                
                {/* Display error messages to the user */}
                {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
            </div>
        </>
    );
};

export default Mystreybox;